import React from 'react';
import { theme } from '@factorin/container.macro';

import { cn } from 'Modules/ui';

import styles from './index.module.scss';


export const FactorinWindow = ({ className, children, overrideFill = true }) => (
    <div className={cn(
        styles.window,
        'hcenter vcenter',
        overrideFill && styles.fillGray,
        className,
    )}
    >
        <theme.logo.Normal />
        {children}
    </div>
);
